module.exports = __webpack_public_path__ + "assets/a5ff0e8fa33074a63aa0fc3cdb1ae521.png";